import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';

const dataKeys = [queryKeys.MODE];

/**
 * keeps track of the mode whether it's modal/card view
 *
 * @returns {{ mode: string, setMode: function }}
 */
const useMode = () => {
  const queryClient = useQueryClient();

  const { data } = useSuspenseQuery({
    queryKey: dataKeys,
    queryFn: ({ queryKey }) => queryClient.getQueryData(queryKey),
  });

  const setMode = (mode) => {
    queryClient.setQueryData(dataKeys, mode);
  };

  return {
    mode: data,
    setMode,
  };
};

export default useMode;
